/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as XClose } from "src/assets/static/images/x-close.svg";
import { ReactComponent as CheckIcon } from "src/assets/static/images/checkicon.svg";
import { ReactComponent as RightArrow } from "src/assets/static/images/rightarrow.svg";
import { ReactComponent as LeftArrow } from "src/assets/static/images/leftarrow.svg";
import { useDispatch, useSelector } from "react-redux";
import actions from "src/store/common/actions";
import useFormatById from "src/hooks/utils/useFormatById";
import { imedil_ge } from ".";
import {
  MED_HISTORY,
  PROFILE_APPEALS,
  PROFILE_COMPENSATIONS,
  PROFILE_POLICY,
  PROFILE_SERVICE_CENTER,
  PROFILE_TRAVEL,
  PROFILE_DOCTOR,
  PROFILE_PROVIDERS,
} from "src/containers/layout";

const SidebarToggle = ({ setOpenSideBar, sideBarClose }) => {
  const [currLangIsEng, setCurrLangIsEng] = useState(false);
  const f = useFormatById();

  const dispatch = useDispatch();

  const changeLang = (lang) => {
    lang === "en" ? setCurrLangIsEng(true) : setCurrLangIsEng(false);
    localStorage.setItem("lang", lang);
    dispatch(actions.setLanguage(lang));
  };

  const lang = useSelector((state) => state.common.lang);

  useEffect(() => {
    lang === "en" ? setCurrLangIsEng(true) : setCurrLangIsEng(false);
  }, [lang]);

  const [openProducts, setOpenProducts] = useState(false);
  const [openMyInsurance, setOpenMyInsurance] = useState(false);
  const [openInsuranceProducts, setOpenInsuranceProducts] = useState(false);
  const handleToggle = () => {
    dispatch(actions.setApplicationDarkMode(!darkMode));
  };

  const darkMode = useSelector((state) => state.common.darkMode);

  return (
    <>
      <div className="dark-overlay"></div>
      <div className="overlay" ref={sideBarClose}>
        <XClose className="closebtn" onClick={() => setOpenSideBar(false)} />
        <div className="overlay-content">
          {!openProducts && !openMyInsurance && !openInsuranceProducts && (
            <>
              <a className="ms-3" onClick={() => setOpenMyInsurance(true)}>
                {f("myProfile.myIncurence")}
                <RightArrow className="float-end mt-1 me-1" />
              </a>
              <Link
                to={PROFILE_DOCTOR}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("myProfile.appointmentDoctor")}
              </Link>
              <a className="ms-3" onClick={() => setOpenProducts(true)}>
                {f("myProfile.remoteServices")}
                <RightArrow className="float-end mt-1 me-1" />
              </a>
              <a
                className="ms-3"
                onClick={() => setOpenInsuranceProducts(true)}
              >
                {f("myProfile.insuranceProducts")}
                <RightArrow className="float-end mt-1 me-1" />
              </a>
            </>
          )}
          {openProducts && (
            <>
              <a
                style={{ backgroundColor: "#163165" }}
                onClick={() => {
                  setOpenProducts(false);
                }}
                className="ps-5"
              >
                <LeftArrow />
                <span className="ms-3">{f("myProfile.remoteServices")}</span>
              </a>
              <Link
                to={"/" + PROFILE_APPEALS}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("breadCrumb.appeals")}
              </Link>
              {/* temporary addition */}
              {/* <a
                className="ms-3"
                href="https://claims.imedil.ge/"
                target="_ blank"
                onClick={() => setOpenSideBar(false)}
              >
                {f("breadCrumb.appeals")}
              </a>
              <a
                className="ms-3"
                href="https://guarantee.imedil.ge/"
                target="_ blank"
                onClick={() => setOpenSideBar(false)}
              >
                {f("breadCrumb.hospitalGuarantee")}
              </a> */}
              <Link
                to={PROFILE_COMPENSATIONS}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("breadCrumb.compensations")}
              </Link>
              <Link
                to={PROFILE_SERVICE_CENTER}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("myProfile.bookingServiceCenter")}
              </Link>
            </>
          )}
          {openMyInsurance && (
            <>
              <a
                style={{ backgroundColor: "#163165" }}
                onClick={() => {
                  setOpenMyInsurance(false);
                }}
                className="ps-5"
              >
                <LeftArrow />
                <span className="ms-3">{f("myProfile.myIncurence")}</span>
              </a>
              <Link
                to={PROFILE_POLICY}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("myProfile.myPolicies")}
              </Link>
              <Link
                to={MED_HISTORY}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("myProfile.myMedHistory")}
              </Link>
              <Link
                to={PROFILE_PROVIDERS}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("myProfile.myProvClinics")}
              </Link>
            </>
          )}
          {openInsuranceProducts && (
            <>
              <a
                style={{ backgroundColor: "#163165" }}
                onClick={() => {
                  setOpenInsuranceProducts(false);
                }}
                className="ps-5"
              >
                <LeftArrow />
                <span className="ms-3">{f("myProfile.insuranceProducts")}</span>
              </a>
              <Link
                to={PROFILE_TRAVEL}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("myProfile.travelInsurance")}
              </Link>
            </>
          )}
        </div>
        <div className="languages-div mb-3 ps-4">
          {/* <div className="row ps-3 pe-3 ps-sm-5 pe-sm-5">
            <div className="col-6 my-auto">Dark Mode</div>
            <div className="col-6">
              <div className="toggle-container">
                <input
                  type="checkbox"
                  className="toggle-checkbox"
                  id="myToggle"
                  checked={darkMode}
                  onChange={handleToggle}
                />
                <label
                  className="toggle-slider"
                  htmlFor="myToggle"
                  tabIndex="0"
                ></label>
              </div>
            </div>
          </div> */}
          <div className="top-border">
            <div className="ms-2 me-3">
              <hr />
            </div>
            <p onClick={() => changeLang("ge")}>
              ქართული{" "}
              {!currLangIsEng && <CheckIcon className="float-end me-2" />}
            </p>
            <p onClick={() => changeLang("en")}>
              English{" "}
              {currLangIsEng && <CheckIcon className="float-end me-2" />}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarToggle;
